import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Package, 
  Users, 
  ShoppingBag, 
  Settings, 
  LogOut,
  ChevronRight,
  Layers,
  Ticket,
  Receipt,
  Image as ImageIcon
} from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const AdminSidebar = () => {
  const location = useLocation();
  const { logout } = useAuth();

  const menuItems = [
    { name: 'Dashboard', icon: LayoutDashboard, path: '/admin/dashboard' },
    { name: 'POS Billing', icon: Receipt, path: '/admin/pos' },
    { name: 'Hero Banners', icon: ImageIcon, path: '/admin/settings?tab=hero' },
    { name: 'Products', icon: Package, path: '/admin/productlist' },
    { name: 'Categories', icon: Layers, path: '/admin/categorylist' },
    { name: 'Orders', icon: ShoppingBag, path: '/admin/orderlist' },
    { name: 'Invoice History', icon: Layers, path: '/admin/billing' },
    { name: 'Users', icon: Users, path: '/admin/userlist' },
    { name: 'Promo Codes', icon: Ticket, path: '/admin/coupons' },
  ];

  return (
    <div className="w-64 bg-secondary-900 text-white min-h-screen sticky top-0 p-6 flex flex-col justify-between">
      <div className="space-y-8">
        <div className="px-4 py-2 bg-primary-600/10 border border-primary-600/20 rounded-2xl">
          <h1 className="text-xl font-black italic text-primary-500 tracking-tighter uppercase">alaiaathi</h1>
          <p className="text-[10px] text-secondary-400 font-bold uppercase tracking-[0.2em]">Admin Panel</p>
        </div>

        <div className="space-y-4">
          <h2 className="text-xs font-bold text-secondary-400 uppercase tracking-widest px-4">Management</h2>
          <nav className="space-y-2">
            {menuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center justify-between px-4 py-3 rounded-2xl transition-all group ${
                  location.pathname === item.path 
                    ? 'bg-primary-600 text-white shadow-lg shadow-primary-900/50' 
                    : 'text-secondary-400 hover:bg-secondary-800 hover:text-white'
                }`}
              >
                <div className="flex items-center space-x-3">
                  <item.icon className="h-5 w-5" />
                  <span className="font-medium">{item.name}</span>
                </div>
                <ChevronRight className={`h-4 w-4 transition-transform ${location.pathname === item.path ? 'rotate-90' : 'group-hover:translate-x-1'}`} />
              </Link>
            ))}
          </nav>
        </div>
      </div>

      <div className="pt-8 border-t border-secondary-800 space-y-4">
        <h2 className="text-xs font-bold text-secondary-400 uppercase tracking-widest px-4">System</h2>
        <nav className="space-y-2">
          <Link to="/admin/settings" className="flex items-center space-x-3 px-4 py-3 rounded-2xl text-secondary-400 hover:bg-secondary-800 hover:text-white transition-all">
            <Settings className="h-5 w-5" />
            <span className="font-medium">Settings</span>
          </Link>
          <button 
            onClick={logout}
            className="w-full flex items-center space-x-3 px-4 py-3 rounded-2xl text-red-400 hover:bg-red-500/10 transition-all text-left"
          >
            <LogOut className="h-5 w-5" />
            <span className="font-medium">Logout</span>
          </button>
        </nav>
      </div>
    </div>
  );
};

export default AdminSidebar;

